export const IS_TENANT_MODE = import.meta.env.VITE_TENANT_MODE === 'true';

export const TENANT_ADMIN_HOME = '/admin/dashboard';
export const TENANT_LOGIN_HOME = '/login';

export function getPostLoginPath(): string {
  return IS_TENANT_MODE ? TENANT_ADMIN_HOME : '/dashboard';
}

export function getStoredUser(): Record<string, unknown> | null {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** Tenant merchant site: any authenticated session goes to admin dashboard. */
export function shouldRedirectTenantToDashboard(): boolean {
  return IS_TENANT_MODE && !!getStoredUser();
}
